module.exports = __webpack_public_path__ + "static/media/photo-1546622891-02c72c1537b6.a3a6a7a6.jpg";